import React from 'react'

export const MOBILE_SIDEBAR_OPEN_BODY_CLASS = 'mobile-sidebar-open'

/** Tracks whether the mobile sidebar overlay is open via body class. */
export const useMobileSidebarOpen = (): boolean => {
  const [open, setOpen] = React.useState(
    () => typeof document !== 'undefined' && document.body.classList.contains(MOBILE_SIDEBAR_OPEN_BODY_CLASS),
  )

  React.useEffect(() => {
    const sync = () => {
      setOpen(document.body.classList.contains(MOBILE_SIDEBAR_OPEN_BODY_CLASS))
    }
    const observer = new MutationObserver(sync)
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] })
    return () => observer.disconnect()
  }, [])

  return open
}
